import TeamCard from './TeamCard';
import moment from 'moment/moment';
import { Api } from '../../../../api';
import { useNavigate } from 'react-router-dom';
import Topbar from '../../../PulseSurvey/Topbar';
import React, { useEffect, useState } from 'react';
import Icons from '../../../../component/svgs/icons';
import { surveyApi } from '../../../../api/surveyApi';
import { CompanyApi } from '../../../../api/companyApi';
import Loader from '../../../../component/common/Loader';
import CommonSelect from '../../../../component/common/select/CommonSelect';
import ChallangeSuccessModal from '../../../../component/common/modals/ChallangeSuccessModal';
import ChallangeApprovalModal from '../../../../component/common/modals/ChallangeApprovalModal';
import { generateWeeksForYear, getPathForSurvey, successToast } from '../../../../utils/helper';
import AddEditWeeklyChallangesValidation from '../../../../validation/AddEditWeeklyChallangesValidation';

const weeks = generateWeeksForYear(moment().year());

const AddEditWeeklyChallanges = () => {
  const navigate = useNavigate();
  const [Id, setId] = useState('');
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [connect, setConnect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [challanges, setChallanges] = useState([]);
  const [adminList, setSuperAdminList] = useState([]);
  const { userType } = JSON.parse(localStorage.getItem('userData'));
  const location = new URLSearchParams(window.location.search);
  const id = location.get('id');
  const week = location.get('week');
  const [error, setError] = useState({
    week: ''
  });
  const [challenge, setChallenge] = useState({
    challengeId: '',
    week: ''
  });

  useEffect(() => {
    week &&
      setChallenge((prev) => {
        return {
          ...prev,
          week: week
        };
      });
  }, []);

  const handleAddWorkout = (e) => {
    if (challenge?.week) {
      navigate(
        getPathForSurvey(`/team-challanges/add-edit-challenges?week=${challenge?.week || 1}`)
      );
      setError({ ...error, [e.target.name]: '' });
    } else {
      setError({ ...error, week: 'Please select week.' });
    }
  };

  const handleChange2 = (e, name) => {
    setChallenge({ ...challenge, [name]: e.value });
    setError({ ...error, [name]: '' });
  };

  const handleClose = () => {
    setOpen(false);
    navigate(getPathForSurvey('/team-challanges'));
  };

  const handleDelete = async (id) => {
    setLoading(true);
    const res = await Api.deleteChallange(id);
    if (res?.data?.meta?.code === 200) {
      successToast(res?.data?.meta?.message);
    } else {
      setLoading(false);
    }
  };

  const getadminList = () => {
    surveyApi.getAdminList(0).then(async (response) => {
      if (response?.data?.meta?.code === 1) {
        setOpen2(true);
        setLoading(false);
        setSuperAdminList(response?.data?.data);
      } else {
        setLoading(false);
      }
    });
  };

  const getadminList2 = () => {
    CompanyApi.getAdminListCompany(3).then(async (response) => {
      if (response?.data?.meta?.code === 1) {
        setOpen2(true);
        setLoading(false);
        setSuperAdminList(response?.data?.data);
      } else {
        setLoading(false);
      }
    });
  };

  const handleSubmit = () => {
    const { errors, isValid } = AddEditWeeklyChallangesValidation(challenge);
    if (isValid) {
      const payload = {
        title: challenge.title,
        description: challenge.description,
        points: challenge.points
      };
      connect && (payload.sync = challenge.sync);
      connect && (payload.connect = connect);
      if (id) {
        payload.challengeId = challenge.challengeId;
        if (userType === 0 || userType === 1) {
          if (userType === 0) {
            payload.status = 1;
            setLoading(true);
            Api.addChallange(payload)
              .then((response) => {
                if (response?.data?.meta?.code === 200) {
                  setOpen(true);
                  setLoading(false);
                  successToast(response?.data?.meta?.message);
                } else {
                  setLoading(false);
                }
              })
              .catch((error) => {
                setLoading(false);
              });
          } else {
            setLoading(true);
            getadminList();
          }
        } else {
          if (userType === 3 || userType === 4) {
            if (userType === 3) {
              setOpen(true);
            } else {
              setLoading(true);
              getadminList2();
            }
          }
        }
      } else {
        if (userType === 0 || userType === 1) {
          if (userType === 0) {
            payload.status = 1;
            setLoading(true);
            Api.addChallange(payload)
              .then((response) => {
                if (response?.data?.meta?.code === 200) {
                  setOpen(true);
                  setLoading(false);
                  successToast(response?.data?.meta?.message);
                } else {
                  setLoading(false);
                }
              })
              .catch((error) => {
                setLoading(false);
              });
          } else {
            setLoading(true);
            getadminList();
          }
        } else {
          if (userType === 3 || userType === 4) {
            if (userType === 3) {
              setOpen(true);
            } else {
              setLoading(true);
              getadminList2();
            }
          }
        }
      }
    } else {
      setError(errors);
    }
  };

  const handleSendChallengeWithApproval = () => {
    if (challenge?.approvalBy) {
      const payload = {
        title: challenge.title,
        description: challenge.description,
        points: challenge.points,
        sync: challenge.sync,
        approvalBy: challenge.approvalBy,
        connect
      };
      challenge.challengeId && (payload.challengeId = challenge.challengeId);
      setOpen(true);
      setOpen2(false);
    } else {
      setError({ ...error, approvalBy: 'Please select admin.' });
    }
  };

  const fetchChallage = () => {
    setLoading(true);
    const query = `page=1&id=${id}`;
    Api.getChallanges(query)
      .then((response) => {
        if (response?.data?.meta?.code === 200) {
          const res = response?.data?.data?.[0];
          setChallenge({
            challengeId: res?._id,
            title: res?.title,
            description: res?.description,
            points: res?.points,
            sync: res?.sync
          });
          setConnect(res?.connect);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (id) {
      fetchChallage();
    }
  }, [id]);

  return (
    <div className="mx-auto max-w-[1640px] hide-scrollbar font-work-sans">
      {loading && <Loader />}
      <div className="font-work-sans lg:ps-5">
        <Topbar title={id ? 'Edit Challenge' : 'New Challenge'} />

        <div className="lg:mt-10 rounded-2xl border-[1.5px] border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor dark:border-none sm:p-6 p-4">
          <div className="text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg">
            <div className="sm:w-[336px]">
              <label htmlFor="points" className="font-medium text-[16px] leading-9 mb-1">
                Week
              </label>
              <div className="input-field">
                <CommonSelect
                  name="week"
                  options={weeks}
                  onChange={(e) => handleChange2(e, 'week')}
                  value={weeks.find((option) => option.value === challenge.week)}
                />
              </div>
              {error.week && <span className="text-red-500 text-sm">{error.week}</span>}
            </div>
            <div className="text-[16px] text-shoorah-lightBlack lg:mt-6 mt-5 dark:text-shoorah-darkBg">
              <label htmlFor="description" className="font-medium text-[16px] leading-9 mb-1">
                Add Challenge
              </label>
              {challanges?.length === 0 ? (
                <button
                  onClick={handleAddWorkout}
                  className="dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBgColor rounded-2xl py-6 cursor-pointer flex items-center justify-center flex-col sm:w-[352px] w-full"
                >
                  <Icons.plusRoundIcon />
                  <h6 className="text-[16px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mt-2">
                    Add Workout
                  </h6>
                </button>
              ) : (
                <div className="h-fit gap-4 grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-shoorah-borderGray rounded-2xl">
                  {challanges?.map((item, index) => (
                    <TeamCard
                      key={index}
                      item={item}
                      Id={Id}
                      setId={setId}
                      handleDelete={handleDelete}
                    />
                  ))}
                </div>
              )}
              {error.description && (
                <span className="text-red-500 text-sm">{error.description}</span>
              )}
            </div>
          </div>
        </div>

        <div className="lg:mt-8 mt-5 flex justify-end">
          <button
            onClick={handleSubmit}
            className="bg-shoorah-secondary text-white px-5 py-2 rounded-full text-[16px] font-medium leading-6 flex items-center gap-2"
          >
            Publish Weekly Challenge <Icons.chevronRightIcon />
          </button>
        </div>
      </div>
      <ChallangeSuccessModal
        open={open}
        btn="Manage Challenge"
        message="You’ve successfully created a challenge"
        desc="You can now manage this challenge and access valuable insights"
        handleClose={handleClose}
      />
      <ChallangeApprovalModal
        open={open2}
        btn="My Challenges"
        message="You're currently unable to share this challenge"
        desc="Send the challenge to an admin to gain approval"
        adminList={adminList}
        error={error.approvalBy}
        handleChange={(e) => {
          setChallenge({ ...challenge, approvalBy: e.value });
          setError({ ...error, approvalBy: '' });
        }}
        handleSendChallengeWithApproval={() => handleSendChallengeWithApproval()}
      />
    </div>
  );
};

export default AddEditWeeklyChallanges;
